import {
  getObject,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { NotApplicableOptionV1 } from "./notApplicableOptionV1";


/**
 * @deprecated Enums should directly be imported from the enum type namespace.
 */
export namespace SingleChoiceDisplayTypeV1Enums {
  export namespace CardDirection {
    
    export namespace HorizontalEnums {
      /* eslint-disable @typescript-eslint/no-shadow */
      export namespace TextAlignment {
        export enum TextAlignment {
          LEFT = "LEFT",
          RIGHT = "RIGHT",
          CENTER = "CENTER",
        }
      
        export interface TextAlignmentDTO {
          case: string;
        }
      
        export const fromDTO = (dto: TextAlignmentDTO): TextAlignment => {
          if (dto === undefined || dto === null) {
            throw new InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError(
              `Invalid DTO ${dto} provided for TextAlignment.TextAlignment`
            );
          }
          switch (dto.case) {
            case "LEFT":
              return TextAlignment.LEFT;
            case "RIGHT":
              return TextAlignment.RIGHT;
            case "CENTER":
              return TextAlignment.CENTER;
            default:
              throw new InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError(
                `Case ${dto.case} is not valid case of TextAlignment.TextAlignment`
              );
          }
        };
      
        export const toDTO = (textAlignment: TextAlignment): TextAlignmentDTO => {
          const enumDTO = {
            case: TextAlignment[textAlignment],
          };
          return enumDTO;
        };
      }
      
    }
    export interface HorizontalDTO {
      case: string;
      textAlignment: HorizontalEnums.TextAlignment.TextAlignmentDTO;
    }
    
    export class Horizontal {
      readonly isCardDirectionHorizontal: boolean = true;
    
      readonly textAlignment: HorizontalEnums.TextAlignment.TextAlignment;
    
    
      constructor(
      textAlignment: HorizontalEnums.TextAlignment.TextAlignment
      ) {
        this.textAlignment = textAlignment;
      }
    
      static fromDTO(dto: HorizontalDTO): Horizontal {
        const textAlignment = HorizontalEnums.TextAlignment.fromDTO(getObject(dto, "textAlignment", InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError));
        return new Horizontal(
          textAlignment
        );
      }
    
      toDTO(): HorizontalDTO {
        const dto: HorizontalDTO = {
          case: "HORIZONTAL",
            textAlignment: HorizontalEnums.TextAlignment.toDTO(this.textAlignment)
        };
        return dto;
      }
      }
    
    Horizontal.prototype.toString = function toString(): string {
      return `CardDirection.HORIZONTAL(textAlignment='${this.textAlignment}')`;
    };
    
    export interface VerticalDTO {
      case: string;
    }
    
    export class Vertical {
      readonly isCardDirectionVertical: boolean = true;
    
    
    
    
    
      toDTO(): VerticalDTO {
        const dto: VerticalDTO = {
          case: "VERTICAL",
        };
        return dto;
      }
      }
    
    Vertical.prototype.toString = function toString(): string {
      return `CardDirection.VERTICAL()`;
    };
    
  
    export type CardDirection = Horizontal | Vertical;
  
    export type CardDirectionDTO = HorizontalDTO | VerticalDTO;
  
    export const fromDTO = (dto: CardDirectionDTO): CardDirection => {
      switch (dto.case) {
        case "HORIZONTAL":
            return Horizontal.fromDTO(dto as HorizontalDTO);
        case "VERTICAL":
            return new Vertical();
        default:
          throw new InvalidSingleChoiceDisplayTypeV1CardCardDirectionError(
              `Case ${dto.case} is not valid case of CardDirection.`
          );
      }
    };
  }
  
}

export namespace SingleChoiceDisplayTypeV1 {
  export interface RadioButtonDTO {
    case: string;
  }
  
  export class RadioButton {
    readonly isSingleChoiceDisplayTypeV1RadioButton: boolean = true;
  
  
  
  
  
    toDTO(): RadioButtonDTO {
      const dto: RadioButtonDTO = {
        case: "RADIO_BUTTON",
      };
      return dto;
    }
    }
  
  RadioButton.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.RADIO_BUTTON()`;
  };
  
  
  export namespace CardEnums {
    export namespace CardDirection {
      
      export namespace HorizontalEnums {
        /* eslint-disable @typescript-eslint/no-shadow */
        export namespace TextAlignment {
          export enum TextAlignment {
            LEFT = "LEFT",
            RIGHT = "RIGHT",
            CENTER = "CENTER",
          }
        
          export interface TextAlignmentDTO {
            case: string;
          }
        
          export const fromDTO = (dto: TextAlignmentDTO): TextAlignment => {
            if (dto === undefined || dto === null) {
              throw new InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError(
                `Invalid DTO ${dto} provided for TextAlignment.TextAlignment`
              );
            }
            switch (dto.case) {
              case "LEFT":
                return TextAlignment.LEFT;
              case "RIGHT":
                return TextAlignment.RIGHT;
              case "CENTER":
                return TextAlignment.CENTER;
              default:
                throw new InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError(
                  `Case ${dto.case} is not valid case of TextAlignment.TextAlignment`
                );
            }
          };
        
          export const toDTO = (textAlignment: TextAlignment): TextAlignmentDTO => {
            const enumDTO = {
              case: TextAlignment[textAlignment],
            };
            return enumDTO;
          };
        }
        
      }
      export interface HorizontalDTO {
        case: string;
        textAlignment: HorizontalEnums.TextAlignment.TextAlignmentDTO;
      }
      
      export class Horizontal {
        readonly isCardDirectionHorizontal: boolean = true;
      
        readonly textAlignment: HorizontalEnums.TextAlignment.TextAlignment;
      
      
        constructor(
        textAlignment: HorizontalEnums.TextAlignment.TextAlignment
        ) {
          this.textAlignment = textAlignment;
        }
      
        static fromDTO(dto: HorizontalDTO): Horizontal {
          const textAlignment = HorizontalEnums.TextAlignment.fromDTO(getObject(dto, "textAlignment", InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError));
          return new Horizontal(
            textAlignment
          );
        }
      
        toDTO(): HorizontalDTO {
          const dto: HorizontalDTO = {
            case: "HORIZONTAL",
              textAlignment: HorizontalEnums.TextAlignment.toDTO(this.textAlignment)
          };
          return dto;
        }
        }
      
      Horizontal.prototype.toString = function toString(): string {
        return `CardDirection.HORIZONTAL(textAlignment='${this.textAlignment}')`;
      };
      
      export interface VerticalDTO {
        case: string;
      }
      
      export class Vertical {
        readonly isCardDirectionVertical: boolean = true;
      
      
      
      
      
        toDTO(): VerticalDTO {
          const dto: VerticalDTO = {
            case: "VERTICAL",
          };
          return dto;
        }
        }
      
      Vertical.prototype.toString = function toString(): string {
        return `CardDirection.VERTICAL()`;
      };
      
    
      export type CardDirection = Horizontal | Vertical;
    
      export type CardDirectionDTO = HorizontalDTO | VerticalDTO;
    
      export const fromDTO = (dto: CardDirectionDTO): CardDirection => {
        switch (dto.case) {
          case "HORIZONTAL":
              return Horizontal.fromDTO(dto as HorizontalDTO);
          case "VERTICAL":
              return new Vertical();
          default:
            throw new InvalidSingleChoiceDisplayTypeV1CardCardDirectionError(
                `Case ${dto.case} is not valid case of CardDirection.`
            );
        }
      };
    }
    
  }
  export interface CardDTO {
    case: string;
    cardDirection: CardEnums.CardDirection.CardDirectionDTO;
  }
  
  export class Card {
    readonly isSingleChoiceDisplayTypeV1Card: boolean = true;
  
    readonly cardDirection: CardEnums.CardDirection.CardDirection;
  
  
    constructor(
    cardDirection: CardEnums.CardDirection.CardDirection
    ) {
      this.cardDirection = cardDirection;
    }
  
    static fromDTO(dto: CardDTO): Card {
      const cardDirection = CardEnums.CardDirection.fromDTO(getObject(dto, "cardDirection", InvalidSingleChoiceDisplayTypeV1CardCardDirectionError));
      return new Card(
        cardDirection
      );
    }
  
    toDTO(): CardDTO {
      const dto: CardDTO = {
        case: "CARD",
          cardDirection: this.cardDirection.toDTO()
      };
      return dto;
    }
    }
  
  Card.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.CARD(cardDirection='${this.cardDirection}')`;
  };
  
  export interface DropdownDTO {
    case: string;
  }
  
  export class Dropdown {
    readonly isSingleChoiceDisplayTypeV1Dropdown: boolean = true;
  
  
  
  
  
    toDTO(): DropdownDTO {
      const dto: DropdownDTO = {
        case: "DROPDOWN",
      };
      return dto;
    }
    }
  
  Dropdown.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.DROPDOWN()`;
  };
  
  export interface DefaultSliderDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class DefaultSlider {
    readonly isSingleChoiceDisplayTypeV1DefaultSlider: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: DefaultSliderDTO): DefaultSlider {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new DefaultSlider(
        notApplicableOption
      );
    }
  
    toDTO(): DefaultSliderDTO {
      const dto: DefaultSliderDTO = {
        case: "DEFAULT_SLIDER",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  DefaultSlider.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.DEFAULT_SLIDER(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface RygSliderDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class RygSlider {
    readonly isSingleChoiceDisplayTypeV1RygSlider: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: RygSliderDTO): RygSlider {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new RygSlider(
        notApplicableOption
      );
    }
  
    toDTO(): RygSliderDTO {
      const dto: RygSliderDTO = {
        case: "RYG_SLIDER",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  RygSlider.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.RYG_SLIDER(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface DefaultScaleDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class DefaultScale {
    readonly isSingleChoiceDisplayTypeV1DefaultScale: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: DefaultScaleDTO): DefaultScale {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new DefaultScale(
        notApplicableOption
      );
    }
  
    toDTO(): DefaultScaleDTO {
      const dto: DefaultScaleDTO = {
        case: "DEFAULT_SCALE",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  DefaultScale.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.DEFAULT_SCALE(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface ScaleWithTextDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class ScaleWithText {
    readonly isSingleChoiceDisplayTypeV1ScaleWithText: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: ScaleWithTextDTO): ScaleWithText {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new ScaleWithText(
        notApplicableOption
      );
    }
  
    toDTO(): ScaleWithTextDTO {
      const dto: ScaleWithTextDTO = {
        case: "SCALE_WITH_TEXT",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  ScaleWithText.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.SCALE_WITH_TEXT(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface NeutralScaleDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class NeutralScale {
    readonly isSingleChoiceDisplayTypeV1NeutralScale: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: NeutralScaleDTO): NeutralScale {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new NeutralScale(
        notApplicableOption
      );
    }
  
    toDTO(): NeutralScaleDTO {
      const dto: NeutralScaleDTO = {
        case: "NEUTRAL_SCALE",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  NeutralScale.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.NEUTRAL_SCALE(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface DefaultNpsDTO {
    case: string;
    isNPSSelectionColored: boolean;
  }
  
  export class DefaultNps {
    readonly isSingleChoiceDisplayTypeV1DefaultNps: boolean = true;
  
    readonly isNPSSelectionColored: boolean;
  
  
    constructor(
    isNPSSelectionColored: boolean
    ) {
      this.isNPSSelectionColored = isNPSSelectionColored;
    }
  
    static fromDTO(dto: DefaultNpsDTO): DefaultNps {
      const isNPSSelectionColored = getBoolean(dto, "isNPSSelectionColored", InvalidSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError);
      return new DefaultNps(
        isNPSSelectionColored
      );
    }
  
    toDTO(): DefaultNpsDTO {
      const dto: DefaultNpsDTO = {
        case: "DEFAULT_NPS",
          isNPSSelectionColored: this.isNPSSelectionColored
      };
      return dto;
    }
    }
  
  DefaultNps.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.DEFAULT_NPS(isNPSSelectionColored='${this.isNPSSelectionColored}')`;
  };
  
  export interface NpsPreFilledColorDTO {
    case: string;
    isNPSSelectionColored: boolean;
  }
  
  export class NpsPreFilledColor {
    readonly isSingleChoiceDisplayTypeV1NpsPreFilledColor: boolean = true;
  
    readonly isNPSSelectionColored: boolean;
  
  
    constructor(
    isNPSSelectionColored: boolean
    ) {
      this.isNPSSelectionColored = isNPSSelectionColored;
    }
  
    static fromDTO(dto: NpsPreFilledColorDTO): NpsPreFilledColor {
      const isNPSSelectionColored = getBoolean(dto, "isNPSSelectionColored", InvalidSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError);
      return new NpsPreFilledColor(
        isNPSSelectionColored
      );
    }
  
    toDTO(): NpsPreFilledColorDTO {
      const dto: NpsPreFilledColorDTO = {
        case: "NPS_PRE_FILLED_COLOR",
          isNPSSelectionColored: this.isNPSSelectionColored
      };
      return dto;
    }
    }
  
  NpsPreFilledColor.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.NPS_PRE_FILLED_COLOR(isNPSSelectionColored='${this.isNPSSelectionColored}')`;
  };
  
  export interface NpsBorderColorDTO {
    case: string;
    isNPSSelectionColored: boolean;
  }
  
  export class NpsBorderColor {
    readonly isSingleChoiceDisplayTypeV1NpsBorderColor: boolean = true;
  
    readonly isNPSSelectionColored: boolean;
  
  
    constructor(
    isNPSSelectionColored: boolean
    ) {
      this.isNPSSelectionColored = isNPSSelectionColored;
    }
  
    static fromDTO(dto: NpsBorderColorDTO): NpsBorderColor {
      const isNPSSelectionColored = getBoolean(dto, "isNPSSelectionColored", InvalidSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError);
      return new NpsBorderColor(
        isNPSSelectionColored
      );
    }
  
    toDTO(): NpsBorderColorDTO {
      const dto: NpsBorderColorDTO = {
        case: "NPS_BORDER_COLOR",
          isNPSSelectionColored: this.isNPSSelectionColored
      };
      return dto;
    }
    }
  
  NpsBorderColor.prototype.toString = function toString(): string {
    return `SingleChoiceDisplayTypeV1.NPS_BORDER_COLOR(isNPSSelectionColored='${this.isNPSSelectionColored}')`;
  };
  

  export type SingleChoiceDisplayTypeV1 = RadioButton | Card | Dropdown | DefaultSlider | RygSlider | DefaultScale | ScaleWithText | NeutralScale | DefaultNps | NpsPreFilledColor | NpsBorderColor;

  export type SingleChoiceDisplayTypeV1DTO = RadioButtonDTO | CardDTO | DropdownDTO | DefaultSliderDTO | RygSliderDTO | DefaultScaleDTO | ScaleWithTextDTO | NeutralScaleDTO | DefaultNpsDTO | NpsPreFilledColorDTO | NpsBorderColorDTO;

  export const fromDTO = (dto: SingleChoiceDisplayTypeV1DTO): SingleChoiceDisplayTypeV1 => {
    switch (dto.case) {
      case "RADIO_BUTTON":
          return new RadioButton();
      case "CARD":
          return Card.fromDTO(dto as CardDTO);
      case "DROPDOWN":
          return new Dropdown();
      case "DEFAULT_SLIDER":
          return DefaultSlider.fromDTO(dto as DefaultSliderDTO);
      case "RYG_SLIDER":
          return RygSlider.fromDTO(dto as RygSliderDTO);
      case "DEFAULT_SCALE":
          return DefaultScale.fromDTO(dto as DefaultScaleDTO);
      case "SCALE_WITH_TEXT":
          return ScaleWithText.fromDTO(dto as ScaleWithTextDTO);
      case "NEUTRAL_SCALE":
          return NeutralScale.fromDTO(dto as NeutralScaleDTO);
      case "DEFAULT_NPS":
          return DefaultNps.fromDTO(dto as DefaultNpsDTO);
      case "NPS_PRE_FILLED_COLOR":
          return NpsPreFilledColor.fromDTO(dto as NpsPreFilledColorDTO);
      case "NPS_BORDER_COLOR":
          return NpsBorderColor.fromDTO(dto as NpsBorderColorDTO);
      default:
        throw new InvalidSingleChoiceDisplayTypeV1Error(
            `Case ${dto.case} is not valid case of SingleChoiceDisplayTypeV1.`
        );
    }
  };
}

export class InvalidSingleChoiceDisplayTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1Error";
  }
}
export class InvalidSingleChoiceDisplayTypeV1RadioButtonError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1RadioButtonError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1CardError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1CardError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1CardCardDirectionError extends InvalidSingleChoiceDisplayTypeV1CardError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1CardCardDirectionError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalError extends InvalidSingleChoiceDisplayTypeV1CardCardDirectionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError extends InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentLeftError extends InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentLeftError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentRightError extends InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentRightError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentCenterError extends InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1CardCardDirectionHorizontalTextAlignmentCenterError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1CardCardDirectionVerticalError extends InvalidSingleChoiceDisplayTypeV1CardCardDirectionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1CardCardDirectionVerticalError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1DropdownError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1DropdownError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1DefaultSliderError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1DefaultSliderError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError extends InvalidSingleChoiceDisplayTypeV1DefaultSliderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1RygSliderError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1RygSliderError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1RygSliderNotApplicableOptionError extends InvalidSingleChoiceDisplayTypeV1RygSliderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1RygSliderNotApplicableOptionError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1DefaultScaleError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1DefaultScaleError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1DefaultScaleNotApplicableOptionError extends InvalidSingleChoiceDisplayTypeV1DefaultScaleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1DefaultScaleNotApplicableOptionError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1ScaleWithTextError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1ScaleWithTextError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1ScaleWithTextNotApplicableOptionError extends InvalidSingleChoiceDisplayTypeV1ScaleWithTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1ScaleWithTextNotApplicableOptionError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1NeutralScaleError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1NeutralScaleError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1NeutralScaleNotApplicableOptionError extends InvalidSingleChoiceDisplayTypeV1NeutralScaleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1NeutralScaleNotApplicableOptionError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1DefaultNpsError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1DefaultNpsError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError extends InvalidSingleChoiceDisplayTypeV1DefaultNpsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1NpsPreFilledColorError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1NpsPreFilledColorError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1NpsPreFilledColorIsNpsSelectionColoredError extends InvalidSingleChoiceDisplayTypeV1NpsPreFilledColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1NpsPreFilledColorIsNpsSelectionColoredError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1NpsBorderColorError extends InvalidSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1NpsBorderColorError";
  }
}

export class InvalidSingleChoiceDisplayTypeV1NpsBorderColorIsNpsSelectionColoredError extends InvalidSingleChoiceDisplayTypeV1NpsBorderColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleChoiceDisplayTypeV1NpsBorderColorIsNpsSelectionColoredError";
  }
}
